import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserType } from '../api/user/user-type';

@Component({
    selector: 'app-instance-selector',
    templateUrl: './instance-selector.component.html',
    styleUrls: ['./instance-selector.component.scss'],
    standalone: false
})
export class InstanceSelectorComponent implements OnInit {

  public userType: UserType;

  public userTypes = UserType;

  constructor(private auth: AuthService) {
    this.userType = this.auth.currentUserType;
  }

  public ngOnInit(): void {
    this.userType = this.auth.currentUserType;
  }
}
